export const styles = {
    Block: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: '100%'
    },
    BlockCenter: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'column',
        width: '100%'
    },
    BlockSmall: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: '95%'
    },
    BlockRow: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'row',
        width: '100%'
    },
    BlockRowRaw: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'row',
    },
    BlockLeft: {
        display: 'flex',
        alignItems: 'flex-start',
        flexDirection: 'column',
        width: '100%'
    },
    BlockRight: {
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
        flexDirection: 'column',
        width: '100%'
    },
    BlockMaxLarge: {
        // BLOK S MAX.PREDNASTAVENOU SIRKOU
        display: 'flex',
        flexDirection: 'column',
        maxWidth: global.screen_max,
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center'
    },
    BlockMaxSmall: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: 320,
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center'
    },
    BlockRound: {
        // BOX okrúhly pre faCheck
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        borderRadius: '50%',
        width: 40,
        height: 40,

        backgroundColor: global.theme_green,
    },
    BlockMenu: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'column',
        width: global.menu_width,
        backgroundColor: global.theme_dark,
    },

    // ************************************************************************************************
    // BUTTONS
    // ************************************************************************************************
    ButtonThemed: {
        color: '#FFFFFF',
        fontSize: 15,
        width: 160,
        height: 36,
        borderRadius: 4,
        textTransform: 'none',
        fontWeight: '400',
        letterSpacing: 0
    },
    ButtonOutlined: {
        color: '#606060',
        fontSize: 15,
        width: 160,
        height: 36,
        borderRadius: 4,
        textTransform: 'none',
        fontWeight: '400',
        letterSpacing: 0,
        border: '1px solid #606060',
    },
    ButtonEmpty: {
        textTransform: 'none',
        fontWeight: 'normal',
        margin: 0,
        padding: 0
    },
    ButtonLink: {
        color: global.theme_dark_gray,
        textTransform: 'none',
        fontWeight: 'normal',
        margin: 0,
        padding: 0
    },
    ButtonBack: {
        color: global.theme_black,
        backgroundColor: global.theme_white,
        width: 150,
        height: 36,
        textTransform: 'none',
        borderColor: global.theme_black
    },
    ButtonSave: {
        color: global.theme_black,
        backgroundColor: global.theme_green,
        width: 150,
        height: 36,
        textTransform: 'none',
        borderColor: global.theme_black
    },
    ButtonSelect: {
        color: global.theme_black,
        backgroundColor: global.theme_gray,
        width: 100,
        height: 30,
        textTransform: 'none',
        borderColor: global.theme_black
    },
    ButtonNext: {
        color: global.theme_white,
        backgroundColor: global.theme_darker_green,
        fontSize: global.font_tiny,
        width: 150,
        height: 36,
        textTransform: 'none'
    },
    ButtonDark: {
        color: global.theme_white,
        backgroundColor: global.theme_medium,
        fontSize: global.font_tiny,
        width: 150,
        height: 36,
        textTransform: 'none'
    },
    ButtonDarkGreen: {
        color: global.theme_white,
        backgroundColor: global.theme_darker_green,
        fontSize: global.font_tiny,
        width: 200,
        height: 40,
        textTransform: 'none'
    },
    ButtonGreen: {
        color: global.theme_white,
        backgroundColor: global.theme_dark_green,
        fontSize: global.font_tiny,
        width: 200,
        height: 40,
        textTransform: 'none'
    },
    ButtonDisabled: {
        // NEAKTIVNY BUTTON
        color: global.theme_white,
        backgroundColor: global.theme_lighter,
        fontSize: global.font_tiny,
        width: 200,
        height: 40,
        textTransform: 'none'
    },
    ButtonMenuBack: {
        color: global.theme_white,
        backgroundColor: global.theme_light,
        textTransform: 'none',
        fontWeight: 'normal',
        margin: 0,
        padding: 0,
        width: 100,
        height: 30,
    },
    ButtonRound: {
        color: global.theme_white,
        backgroundColor: global.theme_light,
        textTransform: 'none',
        fontWeight: 'normal',
        margin: 0,
        padding: 0,
        width: 36,
        height: 36,
        borderRadius: '50%'
    },
    ButtonRoundBorder: {
        color: global.theme_white,
        border: '2px solid ' + global.theme_light,
        textTransform: 'none',
        fontWeight: 'normal',
        margin: 0,
        padding: 0,
        width: 26,
        height: 26,
        borderRadius: '50%'
    },
    ButtonRoundOrder: {
        color: global.theme_white,
        border: '2px solid #BBBBBB',
        textTransform: 'none',
        fontWeight: 'normal',
        margin: 0,
        padding: 0,
        width: 30,
        height: 30,
        borderRadius: '50%'
    },
    ButtonMenu: {
        color: global.theme_gray,
        backgroundColor: global.theme_light,
        textTransform: 'none',
        fontWeight: 'normal',
        justifyContent: 'left',
        margin: 0,
        padding: 0,
        paddingLeft: 20,
        width: global.menu_width - 60,
        height: 40,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopRightRadius: 20,
        borderBottomRightRadius: 20,
        fontSize: global.font_small,
    },
    ButtonClose: {
        color: '#000000',
        fontSize: 15,
        width: 30,
        height: 30,
        borderRadius: 15,
        textTransform: 'none',
        fontWeight: '400',
        backgroundColor: '#FFFFFF'
    },
    ButtonIcon: {
        color: '#000000',
        fontSize: 14,
        width: 30,
        height: 30,
        borderRadius: 15,
        textTransform: 'none',
        fontWeight: '400',
        //backgroundColor: '#FFFFFF',
        border: '1px solid #B0B0B0'
    },

    /*
    *
    * =================================================================================================================
    * TEXT
    * =================================================================================================================
    *
    */
    TextDialogLabel: {
        fontWeight: '500',
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        fontSize: 18,
        letterSpacing: 0.2,
        color: '#000000',
    },
    TextXSmall: {
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        fontSize: global.font_xsmall,
        color: '#000000',
        textAlign: 'left'
    },
    TextXTiny: {
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        fontSize: global.font_xtiny,
        color: '#000000',
        textAlign: 'left'
    },
    Label: {
        fontSize: global.font_label,
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        color: global.theme_black,
        fontWeight: 'bold'
    },
    TextBlog: {
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        fontSize: global.font_blog,
        color: global.theme_black,
    },
    TextXXLarge: {
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        fontSize: global.font_xxlarge,
        color: global.theme_black,
    },
    TextXLarge: {
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        fontSize: global.font_xlarge,
        color: global.theme_black,
    },
    TextLabel: {
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        fontSize: global.font_label,
        color: global.theme_black,
        fontWeight: 'normal',
        letterSpacing: 2
    },
    TextLarge: {
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        fontSize: global.font_large,
        color: global.theme_black,
    },
    TextNormal: {
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        fontSize: global.font_normal,
        color: global.theme_black,
    },
    TextSmall: {
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        fontSize: global.font_small,
        color: global.theme_black,
    },
    TextTiny: {
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        fontSize: global.font_tiny,
        color: global.theme_black,
    },
    TextXXTiny: {
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        fontSize: global.font_xxtiny,
        color: global.theme_black,
    },
    TextXXXTiny: {
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        fontSize: global.font_xxxtiny,
        color: global.theme_black,
    },
    BorderTop:
    {
        borderTop: '1px solid ' + global.theme_light_gray
    },
    BorderTopBold:
    {
        borderTop: '2px solid ' + global.theme_light_gray
    },
    BorderBottom:
    {
        borderBottom: '1px solid ' + global.theme_light_gray
    },
    Border:
    {
        border: '1px solid ' + global.theme_light_gray
    },
    BorderLeft:
    {
        borderLeft: '1px solid ' + global.theme_light_gray
    },
    BorderRight:
    {
        borderRight: '1px solid ' + global.theme_light_gray
    },
    MenuLine:
    {
        marginTop: 0,
        marginBottom: 10,
        height: 1,
        justifySelf: 'center',
        alignSelf: 'center',
        width: global.menu_width - 70,
        borderTop: '1px solid ' + global.theme_dark_gray
    },
};
